/**
 * Formata segundos para o formato "Xh Ym Zs"
 * @param {number} segundos - Tempo em segundos
 * @returns {string} - Tempo formatado
 */
export function formatTempo(segundos) {
  if (!segundos || segundos === 0) return '0s';

  const horas = Math.floor(segundos / 3600);
  const minutos = Math.floor((segundos % 3600) / 60);
  const segs = Math.floor(segundos % 60);

  let resultado = '';
  if (horas > 0) resultado += `${horas}h `;
  if (minutos > 0) resultado += `${minutos}m `;
  if (segs > 0 || resultado === '') resultado += `${segs}s`;

  return resultado.trim();
}

/**
 * Calcula segundos até a próxima segunda-feira
 * @returns {number} - Segundos até a próxima segunda-feira
 */
export function segundosAteProximaSegunda() {
  const agora = new Date();
  const diaSemana = agora.getDay(); // 0 = Domingo, 1 = Segunda, ...
  const diasAteSegunda = (8 - diaSemana) % 7; // 0 se hoje for segunda
  
  const proximaSegunda = new Date(agora);
  proximaSegunda.setDate(agora.getDate() + diasAteSegunda);
  proximaSegunda.setHours(0, 0, 0, 0);
  
  return Math.floor((proximaSegunda - agora) / 1000);
}

/**
 * Calcula segundos até o próximo mês
 * @returns {number} - Segundos até o próximo mês
 */
export function segundosAteProximoMes() {
  const agora = new Date();
  const proximoMes = new Date(agora.getFullYear(), agora.getMonth() + 1, 1);
  
  return Math.floor((proximoMes - agora) / 1000);
}

/**
 * Formata uma data para tempo relativo (ex: "2h ago", "1d ago")
 * @param {string|Date} timestamp - Timestamp ISO ou Date object
 * @returns {string} - Tempo relativo formatado
 */
export function formatTimeAgo(timestamp) {
  if (!timestamp) return 'Agora';
  
  const now = new Date();
  const past = new Date(timestamp);
  const diffInSeconds = Math.floor((now - past) / 1000);
  
  if (diffInSeconds < 60) return 'Agora';
  if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m atrás`;
  if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h atrás`;
  if (diffInSeconds < 604800) return `${Math.floor(diffInSeconds / 86400)}d atrás`;
  if (diffInSeconds < 2592000) return `${Math.floor(diffInSeconds / 604800)}sem atrás`;
  if (diffInSeconds < 31536000) return `${Math.floor(diffInSeconds / 2592000)}mês atrás`;
  return `${Math.floor(diffInSeconds / 31536000)}ano atrás`;
}

/**
 * Obtém URL do avatar do Discord
 * @param {string} discordId - ID do Discord
 * @param {string} avatarHash - Hash do avatar do Discord
 * @returns {string} - URL do avatar
 */
export function getDiscordAvatarUrl(discordId, avatarHash) {
  if (avatarHash) {
    return `https://cdn.discordapp.com/avatars/${discordId}/${avatarHash}.png?size=256`;
  }
  return `https://cdn.discordapp.com/embed/avatars/${parseInt(discordId) % 5}.png`;
}

/**
 * Extrai o ID do vídeo do YouTube de uma URL
 */
export function extractYouTubeId(url) {
  if (!url) return null;
  
  // Padrões para URLs de watch, embed, short e URLs curtas
  const patterns = [
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=|embed\/|v\/|shorts\/|)([\w-]{11})(?:\S+)?/,
    /(?:https?:\/\/)?(?:www\.)?(?:m\.youtube\.com)\/(?:watch\?v=|embed\/|v\/|shorts\/|)([\w-]{11})(?:\S+)?/
  ];
  
  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match) {
      return match[1];
    }
  }
  
  return null;
}

/**
 * Valida se a URL é uma URL válida do YouTube
 */
export function validateYouTubeUrl(url) {
  return extractYouTubeId(url) !== null;
}

/**
 * Gera a URL da thumbnail do YouTube
 */
export function getYouTubeThumbnail(videoId) {
  if (!videoId) return null;
  return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
}